import { useEffect } from "react";
import { BOUTIQUE_BRAND_COLORS as NAV_COLORS } from "../lib/boutiqueBrandColors";

const COLORS = { PLT: "#22C55E", FLL: "#0EA5E9", WYN: "#EC4899", PNC: "#F97316", RNO: "#C99D36", CC: "#92262D" };
// Approved vivid wallpaper: PLT matches option 3. Other hues retain equal
// perceptual lightness, with chroma bounded to the sRGB gamut.
const WALLPAPER_COLORS = { PLT:"#ADEFC6", FLL:"#BAE3FF", WYN:"#FFCDDF", PNC:"#FFD2BC", RNO:"#F8D99A", CC:"#FFD0CD" };
const NAMES = { PLANTATION: "PLT", "FORT LAUDERDALE": "FLL", WYNWOOD: "WYN", PINECREST: "PNC", RINO: "RNO", "CHERRY CREEK": "CC" };
const NEUTRAL = "#74707c";

export function selectBoutiqueWallpaper(value) {
  const code = String(value || "").toUpperCase();
  if (!COLORS[code] && code !== "RAINBOW") return;
  try { localStorage.setItem("toto-wallpaper-boutique", code); } catch { /* Storage is optional. */ }
  document.documentElement.style.setProperty("--toto-boutique-color", COLORS[code] || NEUTRAL);
  document.documentElement.style.setProperty("--toto-wallpaper-color", WALLPAPER_COLORS[code] || "#ecebed");
  document.documentElement.style.setProperty("--toto-navigation-color", NAV_COLORS[code] || NEUTRAL);
  window.dispatchEvent(new Event("toto-boutique-wallpaper-changed"));
}

export function boutiqueWallpaperCode(user) {
  for (const value of [user?.boutique_code, user?.boutique_name, user?.boutique]) {
    const identity = String(value || "").trim().toUpperCase();
    if (COLORS[identity]) return identity;
    if (NAMES[identity]) return NAMES[identity];
  }
  return null;
}

export default function useBoutiqueWallpaper(user) {
  const code = boutiqueWallpaperCode(user);
  const signedIn = Boolean(user);
  const account = user?.user_id || user?.id || null;
  useEffect(() => {
    let remembered = null;
    let previousAccount = null;
    try {
      remembered = localStorage.getItem("toto-wallpaper-boutique");
      previousAccount = sessionStorage.getItem("toto-wallpaper-account");
    } catch { /* Appearance remains available when storage is disabled. */ }
    // The public boutique selection survives reloads. Its account marker
    // lets a different employee start with their own assigned boutique.
    const saved = COLORS[remembered] || remembered === "RAINBOW" ? remembered : null;
    // Unassigned accounts keep their selected appearance when one exists.
    // Unassigned accounts start with the requested Plantation wallpaper.
    // This preference never scopes operational API requests.
    const initial = (account && previousAccount === String(account) ? saved : null) || code || saved || (signedIn ? "PLT" : null);
    try {
      if (account) sessionStorage.setItem("toto-wallpaper-account", String(account));
    } catch { /* Storage is optional. */ }
    if (initial) selectBoutiqueWallpaper(initial);
    else {
      document.documentElement.style.setProperty("--toto-boutique-color", NEUTRAL);
      document.documentElement.style.setProperty("--toto-wallpaper-color", "#ecebed");
      document.documentElement.style.setProperty("--toto-navigation-color", NEUTRAL);
    }
  }, [code, signedIn, account]);
}
